export const PREVIEW_TABS = [{ value: "email", label: "Email" }] as const;

export type PreviewTab = (typeof PREVIEW_TABS)[number]["value"];

export const SCREEN_SIZES = ["small", "medium", "large"] as const;

export type ScreenSize = (typeof SCREEN_SIZES)[number];

/**
 * The width each size renders its document at: Small and Medium at Figma's frames, Large at least at its
 * breakpoint (it fills the page above that). A size that does not fit the page keeps this width and is
 * scaled down, so the preview's media queries always see the size that was picked.
 */
export const SCREEN_SIZE_WIDTHS: Record<ScreenSize, number> = { small: 400, medium: 834, large: 1025 };

export const SCREEN_SIZE_LABELS: Record<ScreenSize, string> = {
  small: "Small (<640px)",
  medium: "Medium (640–1024)",
  large: "Large (>1024px)",
};

/** The first of the legacy fallback options; the legacy preview fell back to it the same way. */
export const BASE_FONT_STACK = "'Arial', Helvetica Neue, Helvetica, sans-serif";

/** The preview document is isolated from the app, so it loads the default font itself. */
export const FIGTREE_STYLESHEET_URL =
  "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600;700&display=swap";

/** The frame's 1px border on each side, which the scaled document has to fit inside. */
export const FRAME_BORDER_WIDTH = 1;

export const THEME_LOAD_ERROR_MESSAGE = "Failed to load the theme";
